/**
 * Public S3 bucket for movie assets (same host as Big Buck Bunny in EventLivestreamPage).
 * Override with REACT_APP_PULINA_MOVIES_S3_BASE if the bucket or region changes.
 */
export const PULINA_MOVIES_S3_BASE = (
  process.env.REACT_APP_PULINA_MOVIES_S3_BASE || 'https://pulina-movies.s3.eu-north-1.amazonaws.com'
)
  .trim()
  .replace(/\/$/, '');

/** Build HTTPS URL for an object key (no leading slash). */
export function pulinaMoviesUrl(key) {
  const k = String(key || '').replace(/^\//, '');
  return k ? `${PULINA_MOVIES_S3_BASE}/${k}` : '';
}
